import type { App_User } from "@/lib/auth/types";

export function Profile_Read_Display_Name(User: App_User): string {
  const Parts = [User.first_name, User.last_name].filter(Boolean);

  if (Parts.length > 0) {
    return Parts.join(" ");
  }

  const Email_Local = User.email?.split("@")[0]?.trim();
  return Email_Local || "Member";
}

export function Profile_Read_Initials(User: App_User): string {
  if (User.first_name || User.last_name) {
    const First = User.first_name?.[0] ?? "";
    const Last = User.last_name?.[0] ?? "";
    const Initials = `${First}${Last}`.toUpperCase();
    if (Initials) {
      return Initials;
    }
  }

  return (User.email?.[0] ?? "U").toUpperCase();
}
